module.exports = __webpack_public_path__ + "img/trunk_8x2_z16.e7351c76.svg";